// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import { alpha } from "@mui/material";
import { deepmerge } from "@mui/utils";

import base from "./base";
import MuiContainer from "./components/MuiContainer";
import MuiPaper from "./components/MuiPaper";
import MuiTextField from "./components/MuiTextField";

const lively = deepmerge(base, {
  components: {
    MuiContainer,
    MuiPaper,
    MuiTextField,
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "#FFFFFF",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          "&$focused:not($error)": {
            color: "#1F64BC",
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          "&.PersonalDrawerIcon": {
            color: "rgba(19, 23, 32, 0.54)",
          },
          "&.AnswerAgainIcon": {
            color: "rgba(19, 23, 32, 0.54)",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&$focused $notchedOutline": {
            borderColor: "#6191EF",
          },
        },
      },
    },
  },
  palette: {
    primary: {
      light: "#97C1FF",
      main: "#6191EF",
      dark: "#1F64BC",
      background: alpha("#6191EF", 0.08),
      contrastText: "rgba(19, 23, 32, 0.87)",
    },
    secondary: {
      light: "#6DFFD7",
      main: "#1DE9A5",
      dark: "#15A78A",
      background: alpha("#1DE9A5", 0.08),
      contrastText: "rgba(19, 23, 32, 0.87)",
    },
    error: {
      light: "#FA898F",
      main: "#F5474F",
      dark: "#CC1821",
      contrastText: "rgba(0, 0, 0, 0.87)",
    },
    warning: {
      light: "#FFDD4B",
      main: "#FFAB00",
      dark: "#C67C00",
      contrastText: "rgba(0, 0, 0, 0.87)",
    },
    info: {
      light: "#6ECBFF",
      main: "#269AE7",
      dark: "#006CB4",
      contrastText: "rgba(0, 0, 0, 0.87)",
    },
    success: {
      light: "#87C98A",
      main: "#48A74C",
      dark: "#39873C",
      contrastText: "rgba(0, 0, 0, 0.87)",
    },
    background: {
      default: "#FFFFFF",
    },
    text: {
      primary: "rgba(19, 23, 32, 0.87)",
      secondary: "rgba(19, 23, 32, 0.54)",
      disabled: "rgba(19, 23, 32, 0.54)",
      hint: "rgba(19, 23, 32, 0.38)",
    },
    grey: {
      50: "#F5F6FA",
      100: "#F1F2F5",
      200: "#E6E7EB",
      300: "#DCDDE0",
      400: "#BFC1C7",
      500: "#98999E",
      600: "#6C6E75",
      700: "#363840",
      800: "#202229",
      900: "#131720",
      A100: "#D2D3D6",
      A200: "#A4A6AB",
      A400: "#515661",
      A700: "#1D2230",
    },
    divider: "#DCDDE0",
    action: {
      active: "#DCDDE0",
      disabledBackground: "rgba(227, 227, 228, 1)",
    },
  },
});

export default lively;
